import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ApiService } from '@core/services/api-service/api.service';
import { CommonService } from '@core/services/common-service/common.service';
import { GlobalConstants } from '@environments/global-Variables';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { PersonDetailModalComponent } from '../person-detail-modal/person-detail-modal.component';

@Component({
  selector: 'weaccess-header-navigation',
  templateUrl: './top-header-navigation.component.html',
  styleUrls: ['./top-header-navigation.component.scss']
})
export class TopHeaderNavigationComponent {

  globalConstants = GlobalConstants;

  currentUserDetails: any = {};
  getImageDataSubscription!: Subscription;
  personalDetailsSubscription!: Subscription;
  profilePic: any = "../../../../assets/img/person-circle.svg";
  personDetailsInfo: any;
  fieldOptionsData: any;
  bsModalRef!: BsModalRef;
  constructor(
    private authService: MsalService,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService,
    private modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    let getCurrentUserDetails: any = localStorage.getItem(this.globalConstants?.CURRENT_USER_DET_KEY);
    this.currentUserDetails = JSON.parse(window.atob(getCurrentUserDetails));
    this.getProfilePic();
  }

  /** Show profile details */
  showProfileDetails() {
    this.fieldOptionsData = this.commonService.getOptionsData();
    this.getPersonData();
  }

  /** Get person details data api implementation */
  getPersonData() {
    let personReqParam = {
      personId: 0
    }
    this.personalDetailsSubscription = this.commonService.getPersonalDetails(personReqParam).subscribe((personDetailsData: any) => {
      this.commonService.setPersonData(personDetailsData);

      this.personDetailsInfo =
      {
        'reqShortName': (personDetailsData?.firstName ? personDetailsData?.firstName[0] : '') + " " + (personDetailsData?.lastName ? personDetailsData?.lastName[0] : ''),
        'reqFullName': (personDetailsData?.firstName ? personDetailsData?.firstName : '') + " " + (personDetailsData?.lastName ? personDetailsData?.lastName : ''),
        'showRequesterName': true,
        'showUpdateButton': true,
        'personDetails': [
          {
            'InfoTitle': "Personal Information",
            'InfoDetails': [
              {
                label: 'First Name',
                value: personDetailsData?.firstName
              }, {
                label: 'Middle Name',
                value: personDetailsData?.middleName
              }, {
                label: 'Last Name',
                value: personDetailsData?.lastName
              }, {
                label: 'Preferred First Name',
                value: personDetailsData?.preferredFirstName
              }, {
                label: 'Date of Birth',
                value: personDetailsData?.birthDate
              }
            ]
          },
          {
            'InfoTitle': "Contact Information",
            'InfoDetails': [
              {
                label: 'Primary Email',
                value: personDetailsData?.addressDetail?.personalemail
              }, {
                label: 'Primary Phone',
                value: personDetailsData?.addressDetail?.personalphone
              }, {
                label: 'Primary Address',
                value: personDetailsData?.addressDetail?.addressLine1
              }, {
                label: 'Apartment/Suit',
                value: personDetailsData?.addressDetail?.addressLine2
              }, {
                label: 'City',
                value: personDetailsData?.addressDetail?.city
              }, {
                label: 'State',
                value: personDetailsData?.addressDetail?.stateProvince
              }, {
                label: 'Zip Code',
                value: personDetailsData?.addressDetail?.postalCode
              }, {
                label: 'Country',
                value: personDetailsData?.addressDetail?.country
              }
            ]
          },
          {
            'InfoTitle': "Job Information",
            'InfoDetails': [
              {
                label: 'Employee ID',
                value: personDetailsData?.jobDetail?.employeeID
              }, {
                label: 'Full/Part Time',
                value: personDetailsData?.jobDetail?.employmentFormId ? 'Full Time' : 'Part Time'
              }, {
                label: 'Employee status',
                value: personDetailsData?.jobDetail?.employeeStatus
              }, {
                label: 'Department',
                value: personDetailsData?.departmentDetail?.departmentName
              }, {
                label: 'Department Start Date',
                value: personDetailsData?.departmentDetail?.startDate
              }, {
                label: 'Program',
                value: personDetailsData?.departmentDetail?.programName
              }, {
                label: 'Supervisor',
                value: personDetailsData?.jobDetail?.supervisor
              }, {
                label: 'Job Title',
                value: personDetailsData?.jobDetail?.title
              }, {
                label: 'Work Email',
                value: personDetailsData?.jobDetail?.domainAddress
              }, {
                label: 'Job Start Date',
                value: personDetailsData?.jobDetail?.startDate
              }
            ]
          }
        ]
      }
      this.showActionModal();
    })
  }

  /** Getting profile picture from Graph API */
  async getProfilePic() {
    this.getImageDataSubscription = await this.apiService.getImage('https://graph.microsoft.com/v1.0/me/photo/$value', '').subscribe((profilePicData: any) => {
      if (profilePicData) {
        this.createImageFromBlob(profilePicData);
      } else {
      }
    })
  }

  /**Image creation from Blob data */
  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.profilePic = reader.result;
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  /** Logout MSAL authentication */
  logoutMsal() {
    this.authService.instance.logout();
  }

  /** Show action modal functionality implementation */
  showActionModal(): void {
    const modalData: any = {
      data: this.personDetailsInfo
    }
    this.bsModalRef = this.modalService.show(PersonDetailModalComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-xl modal-dialog-centered',
      initialState: modalData
    });
    this.bsModalRef.onHide?.subscribe((res) => { });
  }

  /** Getting the dropdown fields name by id from filtering the field options */
  getFieldDataByID(type: any, OptionsData: any, value: any) {
    if (type === 'area') {
      return OptionsData?.filter((s: any) => s.id === value)[0]?.areaName ? OptionsData?.filter((s: any) => s.id === value)[0]?.areaName : '-';
    } else if (type === 'department') {
      return OptionsData?.filter((s: any) => s.id === value)[0]?.departmentName ? OptionsData?.filter((s: any) => s.id === value)[0]?.departmentName : '-';
    } else if (type === 'program') {
      return OptionsData?.filter((s: any) => s.programId === value)[0]?.programName ? OptionsData?.filter((s: any) => s.programId === value)[0]?.programName : '-';
    } else if (type === 'supervisor') {
      return OptionsData?.filter((s: any) => s.personId === value)[0]?.fullName ? OptionsData?.filter((s: any) => s.personId === value)[0]?.fullName : '-';
    } else if (type === 'location') {
      return OptionsData?.filter((s: any) => s.id === value)[0]?.locationName ? OptionsData?.filter((s: any) => s.id === value)[0]?.locationName : '-';
    } else if (type === 'state') {
      return OptionsData?.filter((s: any) => s.stateId === value)[0]?.stateName ? OptionsData?.filter((s: any) => s.stateId === value)[0]?.stateName : '-';
    } else if (type === 'position') {
      return OptionsData?.filter((s: any) => s.employmentTypeId === value)[0]?.empType ? OptionsData?.filter((s: any) => s.employmentTypeId === value)[0]?.empType : '-';
    }
  }
}
